/**
 * Returns the Unicode flag emoji for a 2-letter ISO 3166-1 alpha-2 country code.
 * Example: "DO" -> "🇩🇴"
 * @param {string} code - Two-letter country code (e.g. DO, US, ES)
 * @returns {string} Flag emoji or empty string if code is invalid
 */
export function getCountryFlag(code) {
  if (!code || typeof code !== 'string') return '';
  const c = code.trim().toUpperCase();
  if (c.length !== 2) return '';
  // Regional Indicator Symbols: A = U+1F1E6, so char N = U+1F1E6 + (N - 65)
  return String.fromCodePoint(...[...c].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65));
}
